// @ts-nocheck
import {
  GET_ALL_POSITIONS_FAIL,
  GET_ALL_POSITIONS_REQUEST,
  GET_ALL_POSITIONS_SUCCESS,
} from "../constants/createEvent";
import {
  CREATE_POSITION_FAILURE,
  CREATE_POSITION_REQUEST,
  CREATE_POSITION_SUCCESS,
  DELETE_POSITION_FAILURE,
  DELETE_POSITION_REQUEST,
  DELETE_POSITION_SUCCESS,
  EDIT_POSITION_FAILURE,
  EDIT_POSITION_REQUEST,
  EDIT_POSITION_STATUS_FAILURE,
  EDIT_POSITION_STATUS_REQUEST,
  EDIT_POSITION_STATUS_SUCCESS,
  EDIT_POSITION_SUCCESS,
  FETCH_POSITION_CATEGORY_SUCCESS,
  FETCH_POSITION_FAILURE,
  FETCH_POSITION_REQUEST,
  FETCH_POSITION_SUCCESS,
  SEARCH_POSITION_BY_TEXT_FAILURE,
  SEARCH_POSITION_BY_TEXT_REQUEST,
  SEARCH_POSITION_BY_TEXT_SUCCESS,
} from "../constants/positions";

const initialState = {
  loading: false,
  searchString: "",
  alertLoading: false,
  data: [],
  allPositions: {
    data: [],
    getAllPositionsRequestLoading: false,
  },
  totalPages: 0,
  currentPage: 1,
  rPerPage: 10,
  statusLoader: false,

  // position categories
  categories: [],
};

const positionReducer = (state = initialState, action) => {
  switch (action.type) {
    // get all positions
    case GET_ALL_POSITIONS_REQUEST:
      return {
        ...state,
        allPositions: {
          ...state?.allPositions,
          getAllPositionsRequestLoading: true,
        },
      };

    case GET_ALL_POSITIONS_SUCCESS:
      return {
        ...state,
        allPositions: {
          ...state?.allPositions,
          getAllPositionsRequestLoading: false,
          data: action.payload?.positions,
        },
        totalPages: action.payload?.totalPages,
        currentPage: action.payload?.currentPage,
      };

    case GET_ALL_POSITIONS_FAIL:
      return {
        ...state,
        allPositions: {
          ...state?.allPositions,
          getAllPositionsRequestLoading: false,
        },
      };

    // start position request
    case FETCH_POSITION_REQUEST:
      return {
        ...state,
        searchString: action.payload?.name,
        rPerPage: action?.payload?.rPerPage,
        loading: true,
      };
    case FETCH_POSITION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data?.positions,
        totalPages: action?.payload?.data?.totalPages,
        currentPage: action?.payload?.data?.currentPage,
      };
    case FETCH_POSITION_FAILURE:
      return {
        ...state,
        loading: false,
      };

    // delete project request
    case DELETE_POSITION_REQUEST:
      return {
        ...state,
        alertLoading: true,
      };
    case DELETE_POSITION_SUCCESS:
      return {
        ...state,
        alertLoading: false,
        data: state.data.filter((_, index) => index !== action.payload),
      };
    case DELETE_POSITION_FAILURE:
      return {
        ...state,
        statusLoader: false,
      };

    // edit position status
    case EDIT_POSITION_STATUS_REQUEST:
      return {
        ...state,
        statusLoader: true,
      };
    case EDIT_POSITION_STATUS_SUCCESS:
      return {
        ...state,
        statusLoader: false,
        data: state.data.map((item) => {
          if (item._id === action.payload) {
            return { ...item, isActive: !item.isActive };
          }
          return item;
        }),
      };
    case EDIT_POSITION_STATUS_FAILURE:
      return {
        ...state,
        alertLoading: false,
      };

    // create position
    case CREATE_POSITION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_POSITION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [action.payload, ...state.data],
      };
    case CREATE_POSITION_FAILURE:
      return {
        ...state,
        loading: false,
      };

    // edit positions
    case EDIT_POSITION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDIT_POSITION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map((item) => {
          if (item._id === action.payload._id) {
            return action.payload;
          }
          return item;
        }),
      };
    case EDIT_POSITION_FAILURE:
      return {
        ...state,
        loading: false,
      };

    // search with text
    case SEARCH_POSITION_BY_TEXT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_POSITION_BY_TEXT_SUCCESS:
      return {
        loading: false,
        data: action.payload?.positions,
        totalPages: action.payload?.totalPages,
        currentPage: action.payload?.currentPage,
      };
    case SEARCH_POSITION_BY_TEXT_FAILURE:
      return {
        ...state,
        loading: false,
      };

    // position categories
    case FETCH_POSITION_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: action?.payload,
      };

    default:
      return state;
  }
};

export { positionReducer, initialState };